import React from 'react';
import styled, { css } from 'styled-components';
import {
  standardColours,
  fontWeights,
  fontSize,
  brandColours,
} from '../styles';
import { formatPrice, isOnSale } from '../utils';

const StyledPrice = styled.p``;

const StyledOldPrice = styled.span`
  color: ${standardColours.darkestGrey};
  font-weight: ${fontWeights.regular};
  ${fontSize(14)};

  ${({ isVariantPrice }) => {
    if (isVariantPrice) {
      return css`
        display: block;
        margin-bottom: 2px;
      `;
    } else {
      return css`
        margin-right: 6px;
      `;
    }
  }}

  span {
    color: ${brandColours.nonary};
  }
`;

const StyledIncVat = styled.span`
  margin-left: 8px;
  color: ${standardColours.grey};
  font-weight: ${fontWeights.regular};
  ${fontSize(18)};
`;

export const ProductPrice = ({
  priceRange: { minVariantPrice, maxVariantPrice },
  variants,
  m2Pricing,
  ...props
}) => {
  const hasSalePrice = isOnSale(variants);

  let lowestCompareAtPrice;

  if (hasSalePrice) {
    const variantsOnSale = variants.filter(
      variant =>
        variant.compareAtPrice !== null &&
        parseFloat(variant.price * (m2Pricing ? 100 : 1)) <
          parseFloat(variant.compareAtPrice * (m2Pricing ? 100 : 1)),
    );

    if (variantsOnSale.length > 1) {
      variantsOnSale.sort(
        (a, b) =>
          parseFloat(a.compareAtPrice * (m2Pricing ? 100 : 1)) -
          parseFloat(b.compareAtPrice * (m2Pricing ? 100 : 1)),
      );
    }

    lowestCompareAtPrice =
      variantsOnSale[0].compareAtPrice * (m2Pricing ? 100 : 1);
  }

  return (
    <StyledPrice hasSalePrice={hasSalePrice} {...props}>
      {hasSalePrice && (
        <StyledOldPrice>
          Was <s>{formatPrice(lowestCompareAtPrice)}</s>
        </StyledOldPrice>
      )}
      <span>
        {minVariantPrice.amount !== maxVariantPrice.amount ? 'From ' : ''}
        {formatPrice(minVariantPrice.amount * (m2Pricing ? 100 : 1))}
      </span>
    </StyledPrice>
  );
};

export const VariantPrice = ({
  variant,
  m2Pricing,
  width,
  height,
  ...props
}) => {
  const hasSalePrice = isOnSale([variant]);
  const { price, compareAtPrice, bundleValue } = variant;

  const getPrice = price =>
    price * (m2Pricing ? Math.ceil((width * height) / 100) : 1);

  return (
    <StyledPrice hasSalePrice={hasSalePrice} {...props}>
      {(hasSalePrice || (bundleValue > 0 && bundleValue > price)) && (
        <StyledOldPrice isVariantPrice={true}>
          {hasSalePrice ? (
            <>
              List:{' '}
              <span>
                <s>{formatPrice(getPrice(compareAtPrice))}</s> (Saving{' '}
                {formatPrice(getPrice(compareAtPrice) - getPrice(price))})
              </span>
            </>
          ) : (
            <span>
              <s>{formatPrice(getPrice(bundleValue))}</s> (Bundle Saving{' '}
              {formatPrice(getPrice(bundleValue) - getPrice(price))})
            </span>
          )}
        </StyledOldPrice>
      )}
      {formatPrice(getPrice(price))}
      <StyledIncVat>
        {formatPrice(getPrice(price) * 1.2)} Incl. VAT
      </StyledIncVat>
    </StyledPrice>
  );
};
